import ContentWrapper from "~/shared/ui/Wrapper/ui/ContentWrapper/ContentWrapper";
import InnerContentWrapper from "~/shared/ui/Wrapper/ui/InnerContentWrapper/InnerContentWrapper";
import FieldWrapper from "~/shared/ui/Wrapper/ui/FieldWrapper/FieldWrapper";

const Wrapper = {
  Content: ContentWrapper,
  InnerContent: InnerContentWrapper,
  Field: FieldWrapper,
};

export default Wrapper;
